const { get, post, put, del } = require("network/http/api");

export const onboardingPost = data => {
  return post(`/user/onboarding`, data);
};
